import { ZipDeviceControlUnit } from '../../controlUnit/controlUnit.model';
import {
  CommanderMonitoringFilterLogicalObject,
  getFilterLogicalObjectFromZipDeviceControlUnits,
} from '../../monitoring/api/util/filter/filter.model';
import * as _ from 'lodash';

/**
 * Check if the filters have been updated by comparing the current device control units
 * with the saved control units in the monitoring filter logical object.
 *
 * @param deviceControlUnits - The current device control units.
 * @param savedControlUnits - The saved control units from the monitoring filter logical object.
 * @param type - The type of filter ('events' or 'channels').
 * @returns {boolean} - Returns true if object keys (the events or channels names) are equal as the saved version.
 *
 * // => true if the filters have been updated, false otherwise
 */
export const areFiltersUpdated = (
  deviceControlUnits: ZipDeviceControlUnit[],
  savedControlUnits: CommanderMonitoringFilterLogicalObject,
  type: 'events' | 'channels'
): boolean => {
  const newObj = getFilterLogicalObjectFromZipDeviceControlUnits(
    deviceControlUnits,
    type
  );

  const result: any = {};
  Object.keys(newObj).forEach((deviceId) => {
    const newValue = newObj[deviceId] ?? {};
    const oldValue = savedControlUnits?.[deviceId] ?? {};
    result[deviceId] = {};
    //Review each control unit

    Object.keys(newValue).forEach((controlUnitId) => {
      result[deviceId][controlUnitId] = _.isEqual(
        Object.keys(newValue[controlUnitId] || {}).sort(),
        Object.keys(oldValue[controlUnitId] || {}).sort()
      );
    });
    Object.keys(oldValue).forEach((controlUnitId) => {
      result[deviceId][controlUnitId] =
        result[deviceId] &&
        _.isEqual(
          Object.keys(newValue[controlUnitId] || {}).sort(),
          Object.keys(oldValue[controlUnitId] || {}).sort()
        );
    });
  });
  return Object.values(result).every((item: any) =>
    Object.values(item).every((value) => value)
  );
};
